// Module
var code = "<div class=demo-mode> <div> <h1 translate>demoMode.landingPage.heading</h1> <p translate>demoMode.landingPage.description</p> <p translate>demoMode.landingPage.notice</p> <a href=# class=get-started-action ng-click=getStarted($event) translate>demoMode.landingPage.actionButton</a> </div> </div>";
// Exports
module.exports = code;